export type ScrollingPreference = boolean;

export type Peripheral = 'mouse' | 'trackpad';

export const BG_DOTTED = 'dotted';
export const BG_GRID = 'grid';
export const BG_NONE = 'none';

export const backgroundPreferenceOptions = [BG_GRID, BG_DOTTED, BG_NONE] as const;
export type BackgroundPreference = typeof BG_DOTTED | typeof BG_GRID | typeof BG_NONE;

export type SnappingPreference = 'snapToObject' | 'snapToGrid';

export type MinimizingPreference = boolean;

export type EquidistantSpacingPreference = boolean;

export interface PreferencesState {
  scrollingPreference: ScrollingPreference;
  snappingPreference: SnappingPreference[];
  backgroundPreference: BackgroundPreference;
  // Used to track what was last used as a background preference for a user.
  // This is so that when a user toggles `hide grid` and `show grid` from the
  // context menu, we can recover the appropriate grid style instead of the
  // default lined style.
  previousBackgroundPreference: BackgroundPreference;
  minimizedPreference: MinimizingPreference;
  equidistantSpacingPreference: EquidistantSpacingPreference;
  // Used as a separate property within preferences that allows us to track
  // experiment state for any experiments being run on the above preferences.
  experiments: PreferencesExperimentState;
}
export interface PreferencesExperimentState {
  hasConfiguredDottedAsDefault: boolean;
}

export const isScrollingPreference = (
  preference: any,
): preference is ScrollingPreference => {
  return typeof preference === 'boolean';
};

export const isBackgroundPreference = (
  preference: any,
): preference is BackgroundPreference => {
  return backgroundPreferenceOptions.includes(preference);
};

export const isMinimizingPreference = (
  preference: any,
): preference is MinimizingPreference => {
  return typeof preference === 'boolean';
};

export const isEquidistantSpacingPreference = (
  preference: any,
): preference is EquidistantSpacingPreference => {
  return typeof preference === 'boolean';
};
